module.exports = __webpack_public_path__ + "img/Gunnlaug_Ydmyker_Ravn.0227c802.jpg";